import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box, Inline, Stack, xcss } from '@atlaskit/primitives';
import { components } from '@atlaskit/select';
import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const optionWrapperStyles = xcss({
  // Enable wrapping text within the option container
  whiteSpace: 'normal'
});
const optionStyles = xcss({
  fontFamily: 'font.family.brand.body'
});
export const CustomOptionInternal = _ref => {
  let {
    label
  } = _ref;
  return /*#__PURE__*/_jsx(Inline, {
    space: "space.100",
    alignBlock: "center",
    grow: "fill",
    xcss: optionWrapperStyles,
    children: /*#__PURE__*/_jsx(Stack, {
      children: /*#__PURE__*/_jsx(Box, {
        xcss: optionStyles,
        children: label
      })
    })
  });
};
export const CustomOption = props => /*#__PURE__*/_jsx(components.Option, _objectSpread(_objectSpread({}, props), {}, {
  children: /*#__PURE__*/_jsx(CustomOptionInternal, _objectSpread({}, props.data))
}));